import { IReducerState } from 'store/main-reducer';

// const isLoading = (state: IReducerState) => state.app.isLoading;
export const getIsMenuOpen = (state: IReducerState) => state.app.isMenuOpen;

export const getIsViewportSmall = (state: IReducerState) => state.browser.is.small;
export const getIsViewportMedium = (state: IReducerState) => state.browser.is.medium;
export const getIsViewportLarge = (state: IReducerState) => state.browser.is.large;
export const getIsViewportXLarge = (state: IReducerState) => state.browser.is.xLarge;
export const getIsViewportXXLarge = (state: IReducerState) => state.browser.is.xxLarge;
export const getMediaType = (state: IReducerState) => state.browser.mediaType;

export const getIsShowingModal = (state: IReducerState) => state.app.isShowingModal;
